/*=========================================================================================
  File Name: module-resource-mutations.js
  Description: Resource Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	Resources: [],
	Orders: [],
	UnpaidOrders: [], //Đơn hàng chưa thanh toán
	IsGetUnpaid: false //Đã get đơn hàng chưa thanh toán
};
